"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRunningInIframe = void 0;
var isRunningInIframe = function () {
    return !(typeof WorkerGlobalScope !== 'undefined' &&
        self instanceof WorkerGlobalScope);
};
exports.isRunningInIframe = isRunningInIframe;
//# sourceMappingURL=sentry-adapter.helper.js.map